import "./styles/SettingsPage.scss";
import React from "react";
import {AsyncGroupSelect, GroupOption} from "./AsyncGroupSelect";
import {useAsync} from "react-use";
import {menuSettingsService} from "../../api/MenuSettingsService";
import {confluenceService} from "../../api/ConfluenceService";
import {errorFlag, successFlag} from "../../model/flags";
import {useFlags} from "@atlaskit/flag";
import Button from "@atlaskit/button/new";
import {FormFooter} from "@atlaskit/form";

function SettingsPage() {
    const [isLoadingEditorGroups, setIsLoadingEditorGroups] = React.useState(false);
    const [isSavingEditorGroups, setIsSavingEditorGroups] = React.useState(false);
    const [selectedGroups, setSelectedGroups] = React.useState<Array<GroupOption>>([]);
    const {showFlag} = useFlags();

    AP.sizeToParent(true);

    useAsync(async () => {
        const initGroups: GroupOption[] = [];
        setIsLoadingEditorGroups(true);

        try {
            const editorGroups = await menuSettingsService.getEditorGroups();
            for (const groupId of editorGroups.groupIds) {
                const group = await confluenceService.getGroupById(groupId);
                initGroups.push({value: group.id, label: group.name});
            }
        } catch (e) {
            handleOperationError("There was an error while fetching editor groups. Please try again later or contact support.");
        }

        setIsLoadingEditorGroups(false);
        setSelectedGroups(initGroups);
    });

    async function saveEditorGroups() {
        setIsSavingEditorGroups(true);
        try {
            await menuSettingsService.setEditorGroups({groupIds: selectedGroups.map(group => group.value)});
            showFlag(successFlag({title: "Success!", description: "The groups have been saved."}));
        } catch (e) {
            handleOperationError("There was an error while saving editor groups. Please try again later or contact support.");
        }
        setIsSavingEditorGroups(false);
    }

    const handleOperationError = (error?: string) => {
        const errMsg = error ?? "There was an error. Please try again later or contact support.";
        showFlag(errorFlag({title: "Error!", description: errMsg}));
    }

    const changeEditorGroups = (groups: any) => {
        setSelectedGroups(groups);
    }

    return (
        <div className={"ac-content menu-settings desktop-view"}>
            <div className={"admin-heading-wrapper "}>
                <h1 className="admin-heading">Menu Settings</h1>
            </div>

            <div className={"desc"}>
                <h3>Editor permissions</h3>
                <p>Grant permission to groups to edit menus. Confluence admins are always able to edit menus.</p>
            </div>

            <div>
                <AsyncGroupSelect onChange={changeEditorGroups} selectedGroups={selectedGroups} isLoading={isLoadingEditorGroups}/>
                <FormFooter align={"start"}>
                    <Button appearance={"primary"} onClick={saveEditorGroups} isLoading={isSavingEditorGroups}>Save</Button>
                </FormFooter>
            </div>
        </div>
    );
}

export default SettingsPage;
